/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const e = "stepper.optionalText", o = "stepper.progBarAriaLabel", r = {
  [e]: "(Optional)",
  [o]: "progressbar"
};
export {
  r as messages,
  e as optionalText,
  o as progBarAriaLabel
};
